import api from './api';

export const companyCamService = {
  getConfigStatus: () => api.get('/companycam/config/status'),
  getOAuthUrl: (state) => api.get(`/companycam/oauth/authorize?state=${state || ''}`),
  // Project-based
  createProject: (data) => api.post('/companycam/projects/create', data),
  linkProject: (data) => api.post('/companycam/projects/link', data),
  getAllProjects: (page = 1, per_page = 25) => api.get(`/companycam/projects/all?page=${page}&per_page=${per_page}`),
  searchProjects: (query, page = 1, per_page = 25) => api.get(`/companycam/projects/search/${encodeURIComponent(query)}?page=${page}&per_page=${per_page}`),
  getProjectMapping: (crmProjectId) => api.get(`/companycam/projects/mapping/${crmProjectId}`),
  unlinkProject: (crmProjectId) => api.delete(`/companycam/projects/unlink/${crmProjectId}`),
  getProjectPhotos: (companyCamProjectId) => api.get(`/companycam/projects/${companyCamProjectId}/photos`),
  uploadPhoto: (companyCamProjectId, formData) => api.post(`/companycam/projects/${companyCamProjectId}/upload-photo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  // Customer-based (NEW)
  createCompanyCamProjectFromCustomer: (customerId) => api.post('/companycam/customers/create', { crm_customer_id: customerId }),
  getCompanyCamCustomerMapping: (customerId) => api.get(`/companycam/customers/mapping/${customerId}`),
  unlinkCompanyCamCustomerProject: (customerId) => api.delete(`/companycam/customers/unlink/${customerId}`),
};
